export default {
  from: {
    new: '새로 만들기',
    'delivery-from': '배송 출발지',
  },
  to: {
    delivered: '배송 완료지',
    deliver: '배송지',
  },
  comment: '운전자 코멘트',
}
